import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { RollForwardInfoContent } from "PFApp/components/rollforward/roll_forward_info_content";
import { Tile } from "PFComponents/tile";
import { Activity } from "PFCore/types";

type RollforwardInfoSectionProps = {
  activity?: Activity;
  isRole?: boolean;
};

export const RollforwardInfoSection = ({
  activity: activityProp,
  isRole: isRoleProp
}: RollforwardInfoSectionProps) => {
  const currentActivity = useCurrentActivity();
  const { isRole: isRoleFromContext } = useActivityShowContext();

  const activity = activityProp ?? currentActivity;
  const isRole = isRoleProp ?? isRoleFromContext;
  const rollforwardInfo = activity?.rollforward_info;

  if (!rollforwardInfo) {
    return null;
  }

  const { source, targets } = rollforwardInfo;
  const bookedProfiles = source?.booked_profiles;
  const hasContent = source || (targets && targets.length > 0) || (isRole && bookedProfiles?.length);

  if (!hasContent) {
    return null;
  }
  return (
    <Tile variant="light" paddingVariant="lg" data-qa-id="ActivityDetailsRollforwardInfo">
      <RollForwardInfoContent mode="button" allowPanelStack={false} />
    </Tile>
  );
};
